import { TableActionsItem, TableActionsWithIconsItem } from './TableActionsProps'

export const sortItems = <T extends TableActionsItem>(items: T[]) => {
  const uniqueItems = items.filter((item) => item.type === 'option')
  const baseItems: T[] = []

  const detailsItem = items.find((item) => item.type === 'details')
  const editItem = items.find((item) => item.type === 'edit')
  const historyItem = items.find((item) => item.type === 'history')
  const deleteItem = items.find((item) => item.type === 'delete')

  if (detailsItem) {
    baseItems.push(detailsItem)
  }
  if (editItem) {
    baseItems.push(editItem)
  }
  if (historyItem) {
    baseItems.push(historyItem)
  }
  if (deleteItem) {
    baseItems.push(deleteItem)
  }

  return {
    uniqueItems,
    baseItems
  }
}

export const getName = (item: TableActionsItem | TableActionsWithIconsItem) => {
  switch (item.type) {
    case 'option':
      return item.title
    case 'details':
      return 'Details'
    case 'delete':
      return 'Delete'
    case 'edit':
      return 'Edit'
    case 'history':
      return 'History'
    default:
      return undefined
  }
}
